import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import LatestGrid from './components/LatestGrid';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <LatestGrid />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '吃瓜网黑料 - 网红塌房现场追踪',
            description: '吃瓜网黑料——聚焦51吃瓜网黑料网站的热门资源与吃瓜网黑料国产精品合集，提供一手博主反差视频与网红塌房现场快讯。',
            url: 'http://yy3uj.cn/',
            isPartOf: {
              '@type': 'WebSite',
              name: '吃瓜网黑料',
              url: 'http://yy3uj.cn/',
            },
            inLanguage: 'zh-CN',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
              },
            ],
          }),
        }}
      />
    </>
  );
}